import { IWorkflowMessageHandler, WorkflowMessage } from 'interfaces-lib';

/**
 * Represents a workflow task.
 */
export abstract class WorkflowTask implements IWorkflowMessageHandler {
  /**
   * The name of the workflow this task represents.
   */
  readonly workflowName: Readonly<string>;

  /**
   * Standard constructor
   * @param workflowName the name of the workflow this task represents
   */
  protected constructor(workflowName: string) {
    this.workflowName = workflowName;
  }

  /**
   * Called when the connection to the server is established and the workflow is recognised.
   */
  workflowStartSuccess(): void {
    console.debug(`WorkflowTask for ${this.workflowName} started.`);
  }

  /**
   * Get the paramaters required to start the workflow this task represents.
   * @returns an object that can be passed to the server to start the workflow
   */
  abstract getStartParams(): any;

  /**
   * Handler for messages received from the server as the workflow executes.
   * @param message the message received
   */
  abstract receive(message: WorkflowMessage): boolean;
}
